import { z } from "zod";

export const CONTACT_STATUSES = ["new", "replied", "archived"] as const;
export const contactStatusSchema = z.enum(CONTACT_STATUSES);
export type ContactStatus = z.infer<typeof contactStatusSchema>;

export const contactMessageInputSchema = z.object({
  name: z.string().trim().min(2, "Tell us your name").max(120),
  email: z.string().trim().email("Enter a complete email address").max(200),
  message: z.string().trim().min(10, "A sentence or two is enough").max(4000),
  locale: z.enum(["en", "id"]).default("en"),
});
export type ContactMessageInput = z.output<typeof contactMessageInputSchema>;

/** Pre-validation shape for React Hook Form (see BookingRequestValues). */
export type ContactMessageValues = z.input<typeof contactMessageInputSchema>;

export const contactMessageSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  email: z.string(),
  message: z.string(),
  status: contactStatusSchema,
  locale: z.string(),
  createdAt: z.string(),
});
export type ContactMessage = z.infer<typeof contactMessageSchema>;
